import Vue from 'vue'
import HasAccess from './HasAccess'

import store from '../../store/index'

let allowance = {
  integration: {
    intercom: true,
    slack: true
  },
  customStatus: true,
  customDomain: true,
  developerApi: true
}

let messaging = {
  board: {
    public: 'You have reached your public board limit.',
    private: 'You have reached your private board limit.'
  },
  integration: {
    intercom: 'Intercom integration is not part of your subscription plan.',
    slack: 'Slack integration is not part of your subscription plan.'
  },
  customStatus: 'Custom Statuses are not part of your subscription plan.',
  customDomain: 'Custom Domains are not part of your subscription plan.',
  developerApi: false
}


const index = (obj, i) => obj[i]

const hasAccess = {
  install: function (Vue, options) {

    Vue.component('has-access', HasAccess)

    Vue.prototype.$allowed = (key) => {

      // console.log(key)
      // console.log(store.state.company.plan.allowance)
      let allowed = key.split('.').reduce(index, store.state.company.plan.allowance)
      let message = key.split('.').reduce(index, messaging)
      // console.log(allowed)

      return {
        block: !allowed,
        message
      }
    }

    Vue.prototype.$block = (key, value) => {
      let allowed = key.split('.').reduce(index, store.state.company.plan.allowance)
      if (allowed !== value) {
        Vue.$DialogBox.open({
          parent: this,
          open: true,
          header: 'No access',
          message: 'Your current plan does not have access to this feature.',
          onConfirm: () => {
            console.log('confirm')
          }
        })
        return true
      }
      return false
    }
  },
}

export default hasAccess
